// extracted by mini-css-extract-plugin
module.exports = {"gothic":"#7996a8","lonchmara":"#0082d6"};